// extracted by mini-css-extract-plugin
module.exports = {"icon":"ConsumablesPackagingFormatSection_icon__Eo_cm"};